import React, { useEffect, useState } from 'react';

const Success = () => {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Extract the session_id from the URL query params
    const query = new URLSearchParams(window.location.search);
    const session_id = query.get('session_id');
    
    if (session_id) {
      setSessionId(session_id);
    }
  }, []);

  return (
    <div className="container" style={{ marginTop: '50px', display: 'flex', justifyContent: 'center' }}>
      <div className="card" style={{ maxWidth: '600px', textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '80px', marginBottom: '20px' }}>⛵✨</div>
        <h2 className="section-title" style={{ color: '#28a745', marginBottom: '10px' }}>
          Payment Successful!
        </h2>
        <p style={{ fontSize: '18px', color: '#555', marginBottom: '30px' }}>
          Thank you for your purchase. We are preparing your order.
          You'll receive an email confirmation shortly!
        </p>
        
        {sessionId && (
          <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '30px' }}>
            <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
              <strong>Order Reference Number:</strong>
            </p>
            <p style={{ margin: '5px 0 0 0', fontSize: '12px', fontFamily: 'monospace', color: '#333', wordBreak: 'break-all' }}>
              {sessionId}
            </p>
          </div>
        )}

        <button 
          onClick={() => window.location.href = '/'}
          style={{ padding: '12px 30px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default Success;
